module.exports = __webpack_public_path__ + "static/media/22.2e5b57e1.jpg";